import { useEffect, useState } from "react";
import { FaBolt, FaGift } from "react-icons/fa";

/* ---------- HELPERS ---------- */

const getWorkshopSundayEnd = (currentDate = new Date()) => {
  const now = currentDate;

  const day = now.getDay(); // 0 = Sunday
  const hours = now.getHours();
  const minutes = now.getMinutes();

  const cutoffPassed =
    day === 0 && (hours > 11 || (hours === 11 && minutes >= 15));

  let daysToAdd;

  if (day === 0) {
    daysToAdd = cutoffPassed ? 7 : 0;
  } else {
    daysToAdd = 7 - day;
  }

  const sunday = new Date(now);
  sunday.setDate(now.getDate() + daysToAdd);
  sunday.setHours(23, 59, 59, 999); // Sunday Midnight

  return sunday;
};


const formatDate = (date) =>
  date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
 


export default function JoinBottomBarPrompts(props) {
  const [showBar, setShowBar] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  
 const pad = (num) => String(num).padStart(2, "0");

const nextSunday = getWorkshopSundayEnd();


  // Show bar after scrolling
  useEffect(() => {
    const handleScroll = () => setShowBar(window.scrollY > 150);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Countdown till Sunday
  useEffect(() => {
  const endTime = nextSunday.getTime();

  const interval = setInterval(() => {
    const diff = Math.floor((endTime - Date.now()) / 1000);
    setTimeLeft(diff > 0 ? diff : 0);
  }, 1000);

  return () => clearInterval(interval);
}, []);


  // OLD DESIGN FORMAT: Day X | Hour Y
  const days = Math.floor(timeLeft / 86400);
  const hours = Math.floor((timeLeft % 86400) / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
const seconds = timeLeft % 60;

  if (!showBar) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full z-50">
      <div className="relative bg-[#0a0a0a] border-t border-white/10 px-4 py-3">
        <div className="relative z-10 max-w-7xl mx-auto flex items-center justify-between gap-3">

          {/* LEFT TEXT */}
          <div className="flex flex-col gap-1 max-w-[68%] sm:max-w-none">
            {/* <p className="text-white text-xs sm:text-base font-medium leading-snug">
              Hurry! Enroll by{" "}
              <span className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#0068FF] to-[#ff3ff9]">
                {formatDate(nextSunday)} | Midnight
              </span>
            </p> */}

            <p className="text-xs lg:text-sm text-white font-medium leading-snug">
            <span className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#0068FF] to-[#ff3ff9] lg:text-lg">
             Chatgpt Prompt Mastery
            </span>
            <br />
            <span className="text-sm lg:text-base text-gray-300">
              Get <span className="text-yellow-400 font-bold">50% OFF</span>
            </span>
          </p>




            {/* OLD STYLE TIMER */}
           {/* <span className="inline-block bg-white/20 text-white text-[11px] sm:text-sm font-medium px-3 py-1 rounded-lg w-fit">
              ⏳ Offer Ends in {pad(days)} : {pad(hours)} : {pad(minutes)} : {pad(seconds)}
            </span> */}

          </div>

          {/* CTA */}
        <a
  target="_blank"
  href="https://learn.nextfutureai.in/web/checkout/685f8b74380b713204ab0841?couponcode=(LEARN50)&purchaseNow=true"
  className="
  px-7 py-3 text-sm
  sm:px-8 sm:py-4 sm:text-base
  lg:px-9 lg:py-4.5 lg:text-base
  rounded-lg font-semibold text-white
  bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
  hover:opacity-90 transition
  flex items-center gap-2
  animate-cta
"

>
  CLAIM 50% OFF
</a>



                    

        </div>
      </div>
    </div>
  );
}
